import { useCallback, useContext } from 'react';
import { StatusCode } from 'grpc-web';
import { AuthContext } from '../contexts/AuthContext';

// Wraps a gRPC-web call with Bearer token auth and a single refresh-and-retry
// on UNAUTHENTICATED. Usage:
//
//   const callWithRetry = useGrpcWithAuth();
//   callWithRetry(
//     (metadata, cb) => client.someRpc(req, metadata, cb),
//     (err, response) => { /* handle result */ }
//   );
const useGrpcWithAuth = () => {
  const { getAccessToken, refreshToken } = useContext(AuthContext);

  return useCallback((grpcCall, callback) => {
    const attempt = (isLastTry) => {
      const metadata = { "Authorization": "Bearer " + getAccessToken() };
      grpcCall(metadata, (err, response) => {
        if (err?.code === StatusCode.UNAUTHENTICATED && !isLastTry) {
          console.log("useGrpcWithAuth: UNAUTHENTICATED, refreshing token and retrying");
          refreshToken().then(() => attempt(true));
          return;
        }
        callback(err, response);
      });
    };
    attempt(false);
  }, [getAccessToken, refreshToken]);
};

export default useGrpcWithAuth;
